import { Building2, UserCheck, Layers, CheckCircle } from "lucide-react";

export const aboutData = {
  intro: {
    eyebrow: "Let's Have Intro...",
    title: "Connecting Data Intelligence With",
    highlight: "Measurable Growth.",
    paragraphs: [
      "Hello, We are the leading providers of top-notch B2B databases tailored to power sales operations across globe-spanning enterprise markets. Navigating complex market dynamics requires reliable, accurate data to empower modern sales forces and revenue operations teams.",
      "Our team of data architects and market analysts works around the clock to cleanse, append, and verify contact profiles. We ensure your sales pipeline connects with authenticated decision-makers and key stakeholders."
    ]
  },

  leadGen: {
    title: "We Help You To Get High Quality B2B Leads",
    description: "Every B2B organization seeks predictability in revenue growth. Our verified datasets eliminate cold outreach friction, reducing bounce rates and giving your team immediate access to validated prospect records.",
    stepsTitle: "5 Easy Steps to Get Started",
    steps: [
      "Configure your Target Industry & Company",
      "Determine Decision-Maker Titles and Scope of Criteria",
      "Complete Validations & Geo-Targeting Filters",
      "Receive and Scrub Prospect Information",
      "Deploy and Scale Your Sales Campaigns"
    ]
  },

  segmentedData: [
    {
      id: "industry",
      title: "Industry Specified Data",
      icon: Building2,
      bulletIcon: CheckCircle,
      points: [
        "Pharma & Healthcare",
        "BFSI & Fintech",
        "IT, Technology & SaaS",
        "Manufacturing & Industrial"
      ]
    },
    {
      id: "roles",
      title: "Roles Specified Data",
      icon: UserCheck,
      bulletIcon: CheckCircle,
      points: [
        "C-Level Executives",
        "VPs & Directors",
        "Founders & Owners",
        "Procurement & IT Leads"
      ]
    },
    {
      id: "aspects",
      title: "Aspects Specified Data",
      icon: Layers,
      bulletIcon: CheckCircle,
      points: [
        "Targeted Information",
        "Company Information",
        "Addressing Information",
        "Verified Direct Phone & Email"
      ]
    }
  
  ],

  ctaBanner: {
    title: "Get the Real Time Data to Boost Your Business",
    buttonText: "Get Started",
    buttonLink: "/contact"
  },

  skills: {
    eyebrow: "Our Skill",
    title: "Boost your Deals and Expand your ROI with our High Quality B2B Data Solutions.",
    description: "Conectify Tech stands behind rigorous data verification workflows. Every record delivered is passed through multi-layered validation layers to ensure campaign deliverability and maximum inbox placement.",
    bars: [
      { label: "DATA ACCURACY", percentage: 85 },
      { label: "DETAIL PROFILING", percentage: 95 },
      { label: "GLOBAL DATA SOLUTIONS", percentage: 92 }
    ]
  }
};